import * as React from "react";
import {
  Text,
  StyleSheet,
  View,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import GlobalStyles from "../../components/GlobalStyles";
import { useSelector } from "react-redux";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import FooterBarWide from "../../components/footerBarWide";
import { useNavigation } from "@react-navigation/native";
import GenericButton from "../../components/GenericButton.js";

export default function DonateTypeSelectScreen() {
  const navigation = useNavigation()
  const win = Dimensions.get("window");
  var donatedAmount =
    useSelector((state) => state.user.userData.balance.amountDonated) || 0;
  var donatedAmount = Number.parseFloat(donatedAmount);
  return (
    <View style={GlobalStyles.containerW}>
      <ScrollView style={styles.scrollArea}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="5" />
            <View style={GlobalStyles.headerContainerKLYellow}>
              <View style={GlobalStyles.headerTextYellow}>
                <Text style={GlobalStyles.headingStyle}>Donation Selection</Text>
                <Text style={GlobalStyles.subheaderStyleWeb}>
                  It's fully automatic and instantaneous once transactions are moved from pending to approved!
                </Text>
              </View>
              {/* <InviteWebHeader /> */}
            </View>
          </View>
        ) : (
          <View style={GlobalStyles.fullHeaderBarW}>
            <StatusBar data="B" />
            <View style={GlobalStyles.headerContainerKL}>
              <View style={GlobalStyles.headerText}>
                <Text style={GlobalStyles.headingStyle}>Donation Selection</Text>
                <Text style={GlobalStyles.subheaderStyle}>
                  It's fully automatic and instantaneous once transactions are moved from pending to approved!
                </Text>
              </View>
            </View>
          </View>
        )}
        {win.width > 768 ? (
          <View style={GlobalStyles.adjustableBodyContainer}>
            <View style={styles.boxSubHeaderColB}>
              <Text style={styles.Amount}>
                $
                {donatedAmount
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
              </Text>
              <Text style={styles.subTextDonated}>DONATED</Text>
              <View style={styles.headerTextB}>
                <Text style={styles.bodyStyle}>
                  Select to donate to your favourite
                  charitable organisation or would you
                  like to support your local club instead?
                </Text>
              </View>
              <View style={styles.bottomContainerWeb}>
                {/* This commented part can be removed in 15/10/23 */}
                {/* <TouchableOpacity
                  style={styles.SubmitButtonStyleWeb}
                  activeOpacity={0.5}
                  onPress={() => navigation.navigate("DonateCharitiesListing")}
                >
                  <Text style={styles.textStyle}>CHARITY</Text>
                </TouchableOpacity> */}
                <View style={styles.buttonContainer}>
                  <GenericButton
                    buttonText='CHARITY'
                    onPress={() => navigation.navigate("DonateCharitiesListing")}
                  />
                </View>
                {/* This commented part can be removed in 15/10/23 */}
                {/* <TouchableOpacity
                  style={styles.SubmitButtonStyleWeb}
                  activeOpacity={0.5}
                  onPress={() => navigation.navigate("DonateClubsListing")}
                >
                  <Text style={styles.textStyle}>CLUB</Text>
                </TouchableOpacity> */}
                <View style={styles.buttonContainer}>
                  <GenericButton
                    buttonText='CLUB'
                    onPress={() => navigation.navigate("DonateClubsListing")}
                  />
                </View>
              </View>
            </View>
          </View>
        ) : (
          <View style={GlobalStyles.adjustableBodyContainer}>
            <View style={styles.bottomContainer}>
              <View style={styles.boxSubHeaderColB}>
                <Text style={styles.Amount}>
                  $
                  {donatedAmount
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                </Text>
                <Text style={styles.subTextDonated}>DONATED</Text>
                <View style={styles.headerTextB}>
                  <Text style={styles.bodyStyle}>
                    Select to donate to your favourite
                    charitable organisation or would you
                    like to support your local club instead?
                  </Text>
                </View>
              </View>
              {/* This commented part can be removed in 15/10/23 */}
              {/* <TouchableOpacity
                style={styles.SubmitButtonStyle}
                activeOpacity={0.5}
                onPress={() => navigation.navigate("DonateCharitiesListing")}
              >
                <Text style={styles.textStyle}>CHARITY</Text>
              </TouchableOpacity> */}
              <View style={styles.buttonContainer}>
                <GenericButton
                  buttonText='CHARITY'
                  onPress={() => navigation.navigate("DonateCharitiesListing")}
                />
              </View>
              {/* This commented part can be removed in 15/10/23 */}
              {/* <TouchableOpacity
                style={styles.SubmitButtonStyle}
                activeOpacity={0.5}
                onPress={() => navigation.navigate("DonateClubsListing")}
              >
                <Text style={styles.textStyle}>CLUB</Text>
              </TouchableOpacity> */}
              <View style={styles.buttonContainer}>
                <GenericButton
                  buttonText='CLUB'
                  onPress={() => navigation.navigate("DonateClubsListing")}
                />
              </View>
            </View>
          </View>
        )}
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  scrollArea: {
    backgroundColor: "#ffffff",
  },
  description: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    textAlign: "left",
    marginBottom: 5,
    lineHeight: 20,
  },
  headerImageBox: {
    flex: 1,
    alignContent: "flex-start",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  imageThumbnailPadding: {
    paddingRight: 50,
    minWidth: 120,
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "left",
    marginBottom: 5,
  },
  imageThumbnail: {
    height: 70,
    width: "100%",
    resizeMode: "contain",
    margin: 1,
  },
  bottomContainerWeb: {
    flex: 1,
    alignItems: "center",
  },
  // textStyle: {
  //   color: "#fff",
  //   textAlign: "center",
  //   fontFamily: "montserrat-bold",
  //   fontSize: 16,
  // },
  Amount: {
    fontFamily: "montserrat-bold",
    fontSize: 40,
    textAlign: "left",
    marginBottom: 5,
    color: "#4EBDEF",
  },
  subTextDonated: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    textAlign: "left",
    color: "#998FA2",
  },
  boxSubHeaderColB: {
    flex: 1,
    padding: 10,
    alignItems: "center",
    maxWidth: 800,
    alignSelf: "center",
  },
  headerTextB: {
    paddingLeft: 0,
    paddingRight: 0,
    padding: 10,
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    textAlign: "left",
    marginBottom: 5,
    lineHeight: 20,
    marginLeft: 5,
    marginRight: 5,
  },
  subheaderStyle: {
    fontFamily: "montserrat-italic",
    fontSize: 12,
    color: "#776c7e",
    textAlign: "left",
    marginBottom: 5,
    paddingRight: 20,
    maxWidth: 300,
  },
  buttonContainer: {
    marginBottom: 10,
    marginTop: 40
  }
});
